import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class CustomFieldsService {

  constructor() { }
  //对于多选框数据处理如下 后端转前端 生成自定义字段 step2
  //20220304 baij 对于多选框数据处理如下 后端转前端
  changDataToOption(item) {
    item = { ...item, checkOption: [] }
    item.fieldExtend?.options.forEach(element => {
      item.checkOption.push({
        label: element,
        value: element,
        checked: this.setChecked(item, element)
      })
    });
    item = { ...item, fieldValue: item.checkOption }
    return item
  }
  setChecked(item, element) {
    let f = false
    if (item.fieldValue) {
      item.fieldValue.forEach(d => {
        if (d === element) {
          f = true
        }
      });
    }
    return f
  }

  // 前端自定义字段值转后端格式
  changeToCustom(data) {
    let obj = {}
    if (data?.customFields && data?.customFields.length > 0) {
      data.customFields.forEach(item => {
        if (item.fieldType === "MultiSelect") {
          this.changDataFromOption(obj, item)
        } else if (item.fieldType === "Picture" || item.fieldType === "File") {
          obj[item.fieldId] = this.changFile(item)
        }
        else {
          obj[item.fieldId] = this.changeTime(item) //暂
        }
      });
    }
    data['custom'] = obj
    return data
  }

  //20220304 baij 对于多选框数据处理如下 前端转后端 
  changDataFromOption(obj, element) {
    let temp = []
    element.fieldValue.forEach((i) => {
      if (i.checked) {
        temp.push(i.value)
      }
    })
    obj[element.fieldId] = temp
  }
  changeTime(element) {
    if (element.fieldType == "Date" && element.fieldValue) {
      return moment(element.fieldValue).format('YYYY-MM-DD')
    } else if (element.fieldType == "Time" && element.fieldValue) {
      return moment(element.fieldValue).format('HH:mm')
    } else if (element.fieldType == "DateTime" && element.fieldValue) {
      // console.log('日期格式',moment(element.fieldValue).format('yyyy-MM-DD HH:mm'))
      return moment(element.fieldValue).format('yyyy-MM-DDTHH:mm')
    }
    else {
      return element.fieldValue
    }
  }
  //新增加文件名字段 
  // changFile(element) {
  //   console.log('changFile', element)
  //   let temp = {}
  //   if (element && element.fieldValue) {
  //     if (element.fileList && element.fileList[0]?.name) {
  //       temp = { fileUrl: element.fieldValue, fileName: element.fileList[0]?.name ? element.fileList[0]?.name : element.fileName }
  //     } else {
  //       temp = { fileUrl: element.fieldValue, fileName: element.fileName ? element.fileName : '-' }
  //     }

  //   }
  //   return temp
  // }
  //新增加文件名字段 新增保存
  changFile(element) {
    // let temp = {}
    let temp = []
    if (element && element.fieldValue &&element.fileList) {
      // if (element.fileList && element.fileList[0]?.name) {
      //   temp = { fileUrl: element.fieldValue, fileName: element.fileList[0]?.name ? element.fileList[0]?.name : element.fileName }
      // } else {
      //   temp = { fileUrl: element.fieldValue, fileName: element.fileName ? element.fileName : '-' }
      // }
      for (let i = 0; i < element.fileList.length; i++) {
        if (element.fileList && element.fileList[i]?.name) {
          temp.push({ fileUrl: element.fieldValue[i], fileName: element.fileList[i]?.name ? element.fileList[i]?.name : element.fileName })
        } else {
          temp.push({ fileUrl: element.fieldValue[i], fileName: element.fileName ? element.fileName : '-' })
        }
      }
    }
    return temp
  }

  //step2  编辑 数据转换 生成自定义字段
  //  saveData:持久化后的自定义字段数据custom
  //  fieldsData:自定义字段配置
  //  fields:自定义字段信息， fieldsData添加上fieldValue值
  changeToCustomEdit(saveData, fieldsData, fields) {
    if (saveData) {
      for (let i = 0; i < fieldsData.length; i++) {
        if (saveData[fieldsData[i].fieldId]) {
          //数组用多选
          var type = Object.prototype.toString.call(saveData[fieldsData[i].fieldId]);
          //20220506 baij 多选框,多图片文件格式
          if (type == '[object Array]') {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]
            }

            if (fieldsData[i].fieldType === "MultiSelect") {
              fields[i] = { ...this.changDataToOption(fields[i]) }
            }
            if (fieldsData[i].fieldType === "Picture" || fieldsData[i].fieldType === "File") {
              fields[i] = { ...this.changFileToUpload(fields[i]) }
            }


          }
          //之前单文件的文件或图片
          else if (type == '[object Object]') {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]?.fileUrl,
              fileName: saveData[fieldsData[i].fieldId]?.fileName
            }
          }
          else {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]
            }
            //20220710 baij 编辑下时间数据转换
            //  this.detailItem.fields = this.detailItem.fields.map((o) => {
            //   if (o.fieldType === 'Time' && o.fieldValue) {
            //     let timer = new Date()
            //     let temp = o.time?o.time: o.fieldValue
            //     let time = timer.getFullYear() + '-' + timer.getMonth() + '-' + timer.getDay() + ' ' + temp
            //     return {
            //       ...o,
            //       time:temp,
            //       fieldValue: new Date(time)
            //     }
            //   }else{
            //     return o
            //   }
            // })
            if (fields[i].fieldType === 'Time') {
              //老数据 时间格式不兼容问题处理
              try {
                if (fields[i].fieldValue.indexOf("Invalid date") > -1) {
                  fields[i].fieldValue = "00:00"
                }
              } catch (e) { }
              let temp = fields[i].time ? fields[i].time : fields[i].fieldValue
              let time = '2022-03-01 ' + temp
              fields[i] = {
                ...fields[i],
                time: temp,
                fieldValue: new Date(time)
              }
            }
            // console.log('编辑下时间数据转换 i', this.detailItem.fields[i] )
          }

        }
        //多选框需要特殊处理 baij 0418
        else {
          if (fieldsData[i].fieldType === 'MultiSelect') {
            fields[i] = {
              ...fields[i],
              fieldValue: []
            }
            fields[i] = { ...this.changDataToOption(fields[i]) }
          }
        }
      }
    } else {
      //兼容处理  多选框需要特殊处理 baij 0421 
      if (fieldsData && fieldsData.length > 0) {
        for (let i = 0; i < fieldsData.length; i++) {
          if (fieldsData[i].fieldType === 'MultiSelect') {
            fields[i] = {
              ...fields[i],
              fieldValue: []
            }
            fields[i] = { ...this.changDataToOption(fields[i]) }

          }
        }
      }

    }
  }

  //查看数据转换 
  getfieldDetails2(saveData, fieldsData, fields) {
    if (saveData) {
      for (let i = 0; i < fieldsData.length; i++) {
        if (saveData[fieldsData[i].fieldId]) {
          //数组用多选
          var type = Object.prototype.toString.call(saveData[fieldsData[i].fieldId]);
          //20220506 baij 多选框,多图片文件格式
          if (type == '[object Array]') {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]
            }

            if (fieldsData[i].fieldType === "MultiSelect") {
              fields[i] = { ...this.changDataToOption(fields[i]) }
            }
            if (fieldsData[i].fieldType === "Picture" || fieldsData[i].fieldType === "File") {
              fields[i] = { ...this.changFileToUpload(fields[i]) }
            }


          }
          //之前单文件的文件或图片
          else if (type == '[object Object]') {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]?.fileUrl,
              fileName: saveData[fieldsData[i].fieldId]?.fileName
            }
          }
          else {
            fields[i] = {
              ...fields[i],
              fieldValue: saveData[fieldsData[i].fieldId]
            }
          }
        }
      }
    }
  }
  //数据转换 生成自定义字段 多图片多文件
  changFileToUpload(element) {
    if (element && element.fieldValue) {
      let fieldValueArray = []
      let fileNameArray = []
      let list = []
      element.fieldValue.forEach((o, index) => {
        if (o) {
          fieldValueArray.push(o.fileUrl)
          fileNameArray.push(o.fileName)
          list.push(
            {
              uid: index + '',
              name: o.fileName,
              status: 'done',
              url: o.fileUrl
            }
          )
        }
      });
      element = {
        ...element,
        fieldValue: fieldValueArray,
        fileName: fileNameArray,
        fileList: list
      }
    }
    return element
  }

  //文件上传处理
  setImgPath(fields, { path, index }) {
    fields[index].fieldValue = fields[index].fieldValue ? fields[index].fieldValue : [];
    fields[index].fileList = fields[index].fileList.slice(-10);
    //编辑初始化
    fields[index].fileList.forEach((o, i) => {
      if (o.url && (o.status && o.status != "removed")) {
        if (fields[index].fieldValue.indexOf(o.url) == -1) {
          fields[index].fieldValue.push(o.url)
        }
      }
    });
    fields[index].fieldValue.push(path)
    // console.log('测试啊 setImgPath', this.detailItem.fields[index].fieldValue)
    // console.log('测试啊 setImgPath的fileList', this.detailItem.fields[index].fileList)
  }
  //文件上传处理
  setImgPathDetail(detail, { path, index }, j) {
    detail[index].fields[j].fieldValue = detail[index].fields[j].fieldValue ? detail[index].fields[j].fieldValue : [];
    detail[index].fields[j].fileList = detail[index].fields[j].fileList.slice(-10);
    //编辑初始化
    detail[index].fields[j].fileList.forEach((o, i) => {
      if (o.url && (o.status && o.status != "removed")) {
        if (detail[index].fields[j].fieldValue.indexOf(o.url) == -1) {
          detail[index].fields[j].fieldValue.push(o.url)
        }
      }
    });
    detail[index].fields[j].fieldValue.push(path)
  }

}
